export default __webpack_public_path__ + "static/media/blood-pressure.fce23972.png";